(() => {
    const initHeader = () => {
        const header = document.querySelector('.header__mobile-menu');
        const button = document.querySelector('.header__burger');

        let opened = false;

        if (!header || !button) {
            return;
        }

        button.addEventListener('click', (e) => {
            e.preventDefault();
            opened = !opened;
            button.classList.toggle('opened', opened);
            header.classList.toggle('opened', opened);
        });

        const mobileArrows = Array.from(header.querySelectorAll('.mobile-arrow'));

        mobileArrows.forEach(arrow => {
            arrow.addEventListener('click', (e) => {
                e.preventDefault();

                try {
                    const subMenu = arrow.closest('.menu-item').querySelector('.sub-menu');

                    arrow.classList.toggle('opened');
                    subMenu.classList.toggle('opened');
                } catch(error) {
                    console.warn('Sub menu not found');
                }
            });
        })
    };

    initHeader();
})();
